import React from "react";
import { useAuthCheck } from "../../hooks/useAuthCheck";
import Loading from "../CustomUI/Loading";

export const withAuth = (WrappedComponent, requiredRoles = []) => {
  return function WithAuthComponent(props) {
    const { isAuthorized, isLoading } = useAuthCheck(requiredRoles);

    if (isLoading) {
      return (
        <div
          className="d-flex justify-content-center align-items-center"
          style={{ height: "100vh" }}
        >
          <Loading />
          <div className="ms-3">Yetkilendirme kontrol ediliyor...</div>
        </div>
      );
    }

    if (!isAuthorized) {
      // Redirect to login if not authorized (useAuthCheck handles navigation internally)
      return null;
    }

    return <WrappedComponent {...props} />;
  };
};
